import { useMemo } from 'react';
import hubHttpClient from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import GenericPopoverHeader from '../components/GenericPopoverHeader';
import useContentInserter from '../hooks/useContentInserter';
import TypeaheadInserterRenderer from './TypeaheadInserterRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY_CONFIG = {};
export default function GenericInserter({
  type,
  definition,
  editorConfig,
  onViewInsertMenu,
  onInsertComplete
}) {
  const runtimeConfig = editorConfig[type] || EMPTY_CONFIG;
  const portalId = PortalIdParser.get();
  const outputType = runtimeConfig.outputType || definition.defaultOutputType;
  const onInsertContentUsage = definition.onInsertContentUsage || 'tracking';
  const transformTransaction = useMemo(() => {
    var _definition$createTra;
    return (_definition$createTra = definition.createTransactionTransform) === null || _definition$createTra === void 0 ? void 0 : _definition$createTra.call(definition, runtimeConfig);
  }, [definition, runtimeConfig]);
  const handleInsert = useContentInserter({
    insertionType: definition.insertionType,
    onInsertComplete,
    onInsertContent: onInsertContentUsage === 'metadata' ? runtimeConfig.onInsertContent : undefined,
    transformTransaction
  });
  const config = definition.typeaheadConfig;
  const apiClient = runtimeConfig.apiClient || hubHttpClient;
  const apiFunctions = useMemo(() => config === null || config === void 0 ? void 0 : config.createApi(apiClient, runtimeConfig), [config, apiClient, runtimeConfig]);
  const rendererProps = {
    onInsert: handleInsert,
    onDismiss: onViewInsertMenu,
    portalId,
    contactEmail: runtimeConfig.contactEmail,
    contactVid: runtimeConfig.contactVid,
    supplementalObjects: runtimeConfig.supplementalObjects
  };
  if (definition.Renderer) {
    return /*#__PURE__*/_jsx(definition.Renderer, Object.assign({}, rendererProps, runtimeConfig));
  }
  if (!config) {
    throw new Error(`Inserter definition for "${type}" has no Renderer and no typeaheadConfig. ` + `Provide one or the other so the inserter can render.`);
  }
  const resolvedManageUrl = typeof config.manageUrl === 'function' ? config.manageUrl(portalId) : config.manageUrl;
  const onTrackSelection = onInsertContentUsage === 'tracking' && runtimeConfig.onInsertContent ? () => runtimeConfig.onInsertContent({
    fromPopover: true
  }) : undefined;
  return /*#__PURE__*/_jsx(TypeaheadInserterRenderer, Object.assign({}, rendererProps, {
    search: apiFunctions.search,
    fetchRenderedContent: apiFunctions.fetchRenderedContent,
    fetchUnrenderedContent: apiFunctions.fetchUnrenderedContent,
    transformData: config.transformData,
    outputType: outputType,
    EmptyState: runtimeConfig.PopoverEmptyState || config.EmptyState,
    ErrorState: runtimeConfig.PopoverErrorState || config.ErrorState,
    Header: runtimeConfig.Header || GenericPopoverHeader,
    searchPlaceholder: config.searchPlaceholder,
    titleMessage: config.titleMessage,
    manageUrl: resolvedManageUrl,
    getNewLinkUrl: config.getNewLinkUrl,
    contentKey: config.contentKey,
    CustomItemComponent: config.CustomItemComponent,
    onTrackSelection: onTrackSelection,
    onClickManageButton: config.onClickManageButton
  }));
}